import React from 'react'
import Layout from "../components/layout"
import { Link } from "gatsby"
import Footer from '../components/footer'
import BgImage from '../images/bg/solutions-page-banner.jpg'
import SocialIconsFooter from '../components/social-icons-footer'

const General = () => {
    return (
        <Layout pageTitle="PragICTS | Cloudops" og_desc="">
            <div id="wrapper" className="single-page-wrap">
                <div className="content" style={{ textAlign: 'left' }}>
                    <div className="single-page-decor"></div>

                    <div className="single-page-fixed-row">
                        <div className="scroll-down-wrap">
                            <div className="mousey"><div className="scroller"></div></div>
                            <span>Scroll Down</span>
                        </div>
                        <Link to="/" className="single-page-fixed-row-link"><i className="fal fa-arrow-left"></i> <span>Back to home</span></Link>
                    </div>

                    {/* Page Header */}
                    <section className="parallax-section dark-bg sec-half parallax-sec-half-right" data-scrollax-parent="true">
                        <div className="bg par-elem" data-bg={BgImage} data-scrollax="properties: { translateY: '30%' }" style={{ backgroundImage: `url(${BgImage})` }}></div>
                        <div className="overlay"></div>
                        <div className="pattern-bg"></div>
                        <div className="container">
                            <div className="section-title" style={{ textAlign: 'left' }}>
                                <h2><span>CLOUDOPS</span></h2>
                                <div className="horizonral-subtitle"><span>CLOUDOPS</span></div>
                            </div>
                            <a href="#pragicts-docs-section" className="custom-scroll-link hero-start-link"><span>Let's Start</span> <i className="fal fa-long-arrow-down"></i></a>
                        </div>
                    </section>

                    {/* New Section: Resource Hub */}
                    <section id="pragicts-docs-section" className="pragicts-docs-wrapper" data-scrollax-parent="true">
    <div className="container">
        <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
            <span>//</span>CLOUDOPS
        </div>

        <ul className="pragicts-docs-menu">
          <li>
        <div class="doc-text">
          <i class="fal pragicts-infrastructure-icon"></i>
          <h4>Cloud Ops</h4>
          <ul>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=QPxAecIHTUk" target="_blank">On Premise Or Cloud</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=n9DZ_pYtjAo" target="_blank">IT, What It Takes To Capitalize</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=eOsAykwmUVA" target="_blank">IT Security - Casual Treatment</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=_JMSjK88WyY" target="_blank">Need For a Fail-over Strategy</a></li>
          </ul>
        </div>
      </li>

        </ul>
    </div>

    {/* Decorative lines */}
    <div className="sec-lines"></div>
</section>



                    <SocialIconsFooter />
                </div>
                <Footer />
            </div>
        </Layout>
    )
}

export default General;
